<!--
  Nueva solicitud de alta de comercio — CONTRATO-REDISENO-ALTAS.md, constructor D. Ruta propia,
  ancho completo, cero modal, tres pasos con `app-riel-pasos`. La carga el ejecutivo comercial:
  queda a su nombre, en la etapa 1.
-->
<div class="kb-page kb-gateway">

  <nav class="kb-migas" aria-label="Ubicación">
    <a class="kb-miga" [routerLink]="['/console/altas']">Altas de comercios</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <span class="kb-miga-actual">Nueva solicitud de alta</span>
  </nav>

  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title">Nueva solicitud de alta</h1>
      <p class="kb-page-meta">
        La cargas tú como ejecutivo comercial; queda a tu nombre, en la etapa 1.
      </p>
    </div>
  </div>

  <div class="an-riel-envoltorio">
    <app-riel-pasos [pasos]="pasosRiel" [navegable]="true" rotulo="Pasos de la nueva solicitud"
                     (elegir)="irAPaso($event)"></app-riel-pasos>
  </div>

  <!-- Lo escrito no se pierde si el ejecutivo sale a otra opción o recarga (se guarda en la pestaña). -->
  <div class="kb-aviso kb-aviso-info" *ngIf="recuperado" role="status">
    <i class="fas fa-undo mt-0.5" aria-hidden="true"></i>
    <div class="flex flex-1 flex-wrap items-center justify-between gap-3">
      <div>
        <p>Seguimos donde te quedaste: esto es lo que habías escrito.</p>
        <p *ngIf="!rifArchivo">El archivo del RIF hay que volver a elegirlo: no se guarda entre visitas.</p>
      </div>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="empezarDeCero()">Empezar de cero</button>
    </div>
  </div>

  <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
    <div>
      <p>{{ error }}</p>
      <ul class="mt-1 list-disc pl-5" *ngIf="detalle.length > 1"><li *ngFor="let d of detalle">{{ d }}</li></ul>
    </div>
  </div>

  <div class="space-y-6">

    <!-- ══ Paso 1 · El comercio ═══════════════════════════════════════════════════════════════ -->
    <div class="kb-card" *ngIf="pasoActual === 'comercio'">
      <div class="kb-card-header">
        <div>
          <p class="kb-seccion-rotulo">El comercio</p>
          <p class="kb-card-desc">Lo que identifica al comercio, para darlo de alta.</p>
        </div>
      </div>
      <div class="kb-card-body">
        <div class="an-grid-2">

          <div>
            <label class="kb-label" for="anNombre">Nombre comercial <span class="kb-texto-peligro">*</span></label>
            <input id="anNombre" type="text" class="kb-input" [(ngModel)]="form.nombre_comercial"
                   (ngModelChange)="alCambiarNombre()">
          </div>

          <div>
            <label class="kb-label" for="anRazon">Razón social <span class="kb-texto-peligro">*</span></label>
            <input id="anRazon" type="text" class="kb-input" [(ngModel)]="form.razon_social">
          </div>

          <!-- URL propia (maqueta aprobada): las siglas del código del comercio. -->
          <div class="an-col-2">
            <label class="kb-label" for="anSiglas">Siglas del código del comercio <span class="kb-texto-peligro">*</span></label>
            <div class="acr-fila">
              <input id="anSiglas" type="text" class="kb-input font-mono an-siglas" maxlength="5" autocomplete="off" spellcheck="false"
                     [(ngModel)]="form.siglas" (ngModelChange)="alEscribirSiglas()"
                     [ngClass]="{'kb-input-invalido': !siglasOk && !!form.siglas}">
              <span class="acr-sufijo font-mono">+ correlativo de 7 dígitos</span>
            </div>
            <div class="acr-estado" *ngIf="form.siglas" [ngClass]="siglasOk ? 'kb-texto-exito' : 'kb-texto-peligro'">
              {{ siglasOk ? '✓ Válidas' : '✗ Escribe de 2 a 5 letras, sin números ni espacios' }}
            </div>
            <p class="kb-hint">El código queda <b class="font-mono">{{ form.siglas || '—' }}</b><span class="font-mono">•••••••</span> (por ejemplo <span class="font-mono">VMAG0000001</span>): las siglas que elijas más un número que el sistema asigna <b>al crear el comercio</b>, por eso todavía no se sabe. Las sugerimos del nombre comercial; puedes cambiarlas. De 2 a 5 letras, sin números. El código no cambia nunca.</p>
          </div>

          <!-- URL propia (maqueta aprobada): el acrónimo de la dirección del portal. -->
          <div class="an-col-2">
            <label class="kb-label" for="anAcronimo">Acrónimo para la dirección del portal <span class="kb-texto-peligro">*</span></label>
            <div class="acr-fila">
              <input id="anAcronimo" type="text" class="kb-input font-mono an-acronimo" maxlength="63" autocomplete="off" spellcheck="false"
                     [(ngModel)]="form.acronimo" (ngModelChange)="alEscribirAcronimo()"
                     [ngClass]="{'kb-input-invalido': acronimoEstado.fase === 'mal'}">
              <span class="acr-sufijo font-mono">{{ sufijoDominio }}</span>
            </div>
            <div class="acr-estado" *ngIf="acronimoEstado.fase !== 'vacio'" aria-live="polite"
                 [ngClass]="acronimoEstado.fase === 'ok' ? 'kb-texto-exito' : (acronimoEstado.fase === 'mal' ? 'kb-texto-peligro' : 'text-muted-foreground')">
              <ng-container *ngIf="acronimoEstado.fase === 'ok'">✔ Disponible · el comercio entrará por <span class="font-mono">{{ direccionDelPortal }}</span>
                <span class="text-muted-foreground" *ngIf="acronimoEstado.sugerido">(sugerido)</span></ng-container>
              <ng-container *ngIf="acronimoEstado.fase === 'mal'">✖ {{ acronimoEstado.mensaje }}</ng-container>
              <ng-container *ngIf="acronimoEstado.fase === 'revisando'">{{ acronimoEstado.mensaje }}</ng-container>
            </div>
            <p class="kb-hint">Es la dirección con la que el comercio entra a su portal. Lo sugerimos a partir del nombre comercial; puedes cambiarlo. Sólo minúsculas, números y guiones.</p>
            <p class="kb-hint">El código del comercio (las siglas de arriba) no se ve en la dirección.</p>
          </div>

          <div>
            <label class="kb-label" for="anRif">RIF <span class="kb-texto-peligro">*</span></label>
            <app-rif-input inputId="anRif" [(valor)]="form.rif" [invalido]="rifInvalido" (tocado)="marcarRifTocado()"></app-rif-input>
            <p class="kb-hint" *ngIf="!rifInvalido">Elige la letra y escribe el número: 8 o 9 dígitos.</p>
            <p class="kb-hint kb-texto-peligro" *ngIf="rifInvalido">{{ rifError }} Por ejemplo J-12345678-9.</p>
          </div>

          <div *ngFor="let p of PIEZAS_FISCAL">
            <label class="kb-label" [for]="'anFiscal_' + p.clave">{{ p.rotulo }} <span class="kb-texto-peligro" *ngIf="p.obligatorio">*</span></label>
            <input [id]="'anFiscal_' + p.clave" type="text" class="kb-input" [(ngModel)]="form.fiscal[p.clave]">
          </div>

          <div>
            <label class="kb-label" for="anTipo">Tipo de persona</label>
            <div class="kb-select-envoltorio">
              <select id="anTipo" class="kb-select" [(ngModel)]="form.tipo_persona">
                <option value="">Sin especificar</option>
                <option value="JURIDICA">Jurídica</option>
                <option value="NATURAL">Natural</option>
              </select>
              <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
            </div>
          </div>

          <div>
            <label class="kb-label" for="anTelefono">Teléfono</label>
            <input id="anTelefono" type="tel" class="kb-input" placeholder="0412-5550101" [(ngModel)]="form.telefono"
                   [ngClass]="{'kb-input-invalido': telefonoInvalido(form.telefono)}">
            <p class="kb-hint kb-texto-peligro" *ngIf="telefonoInvalido(form.telefono)">{{ AYUDA_TELEFONO }}</p>
          </div>

          <div>
            <label class="kb-label" for="anCorreo">Correo</label>
            <input id="anCorreo" type="email" class="kb-input" [(ngModel)]="form.correo">
          </div>

          <div class="an-col-2">
            <label class="kb-label" for="anDescripcion">Descripción <span class="kb-texto-peligro">*</span></label>
            <textarea id="anDescripcion" class="kb-textarea" rows="3" [(ngModel)]="form.descripcion"></textarea>
          </div>

        </div>
      </div>
    </div>

    <!-- ══ Paso 2 · Contacto administrador ════════════════════════════════════════════════════ -->
    <div class="kb-card" *ngIf="pasoActual === 'contacto'">
      <div class="kb-card-header">
        <div>
          <p class="kb-seccion-rotulo">Contactos</p>
          <p class="kb-card-desc">El administrador es obligatorio: nombre y correo o teléfono.</p>
        </div>
      </div>
      <div class="kb-card-body space-y-4">

        <div class="an-fila" *ngFor="let c of contactos; let i = index">
          <div class="an-grid-2">

            <div>
              <label class="kb-label" [for]="'anPapel' + i">Papel</label>
              <div class="kb-select-envoltorio">
                <select [id]="'anPapel' + i" class="kb-select" [(ngModel)]="c.papel">
                  <option *ngFor="let p of PAPELES" [value]="p.codigo">{{ p.nombre }}</option>
                </select>
                <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
              </div>
            </div>

            <div>
              <label class="kb-label" [for]="'anNombreC' + i">Nombre</label>
              <input [id]="'anNombreC' + i" type="text" class="kb-input" [(ngModel)]="c.nombre">
            </div>

            <div>
              <label class="kb-label" [for]="'anCorreoC' + i">Correo</label>
              <input [id]="'anCorreoC' + i" type="email" class="kb-input" [(ngModel)]="c.correo">
            </div>

            <div class="an-fila-tel">
              <div class="flex-1">
                <label class="kb-label" [for]="'anTelC' + i">Teléfono</label>
                <input [id]="'anTelC' + i" type="tel" class="kb-input" placeholder="0412-5550101" [(ngModel)]="c.telefono"
                       [ngClass]="{'kb-input-invalido': telefonoInvalido(c.telefono)}">
                <p class="kb-hint kb-texto-peligro" *ngIf="telefonoInvalido(c.telefono)">{{ AYUDA_TELEFONO }}</p>
              </div>
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon text-destructive"
                      title="Quitar el contacto" [attr.aria-label]="'Quitar el contacto ' + (i + 1)"
                      (click)="quitarContacto(i)">
                <i class="fas fa-trash-alt" aria-hidden="true"></i>
              </button>
            </div>

          </div>
          <p class="kb-hint kb-texto-peligro mt-2" *ngIf="filaAMedias(c)">
            Le falta el nombre, o le falta el correo y el teléfono a la vez, o el teléfono no es válido.
          </p>
        </div>

        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="agregarContacto()">
          <i class="fas fa-plus" aria-hidden="true"></i>Agregar contacto
        </button>

      </div>
    </div>

    <!-- ══ Paso 3 · RIF en archivo ═════════════════════════════════════════════════════════════ -->
    <div class="kb-card" *ngIf="pasoActual === 'archivo'">
      <div class="kb-card-header">
        <div>
          <p class="kb-seccion-rotulo">RIF en archivo</p>
          <p class="kb-card-desc">El documento del RIF, para que el Gerente comercial lo revise.</p>
        </div>
      </div>
      <div class="kb-card-body">
        <label class="kb-label" id="anRifArchivoRotulo">RIF en archivo <span class="kb-texto-peligro">*</span></label>
        <div class="an-archivo" role="group" aria-labelledby="anRifArchivoRotulo">
          <label class="kb-btn kb-btn-outline kb-btn-sm cursor-pointer">
            <i class="fas fa-file-upload" aria-hidden="true"></i>{{ rifArchivo ? 'Cambiar archivo' : 'Elegir archivo' }}
            <input type="file" class="sr-only" accept="application/pdf,image/jpeg,image/png" (change)="elegirArchivoRif($event)">
          </label>
          <span class="an-archivo-nombre" *ngIf="rifArchivo">
            <i class="fas" [ngClass]="rifArchivo.type === 'application/pdf' ? 'fa-file-pdf' : 'fa-file-image'" aria-hidden="true"></i>
            {{ rifArchivo.name }} · {{ pesoArchivo(rifArchivo.size) }}
          </span>
        </div>
        <p class="kb-hint" *ngIf="!errorRif">PDF o foto, hasta 8 MB.</p>
        <p class="kb-hint kb-texto-peligro" *ngIf="errorRif">{{ errorRif }}</p>
      </div>
    </div>

  </div>

  <!-- ══ Pie ═══════════════════════════════════════════════════════════════════════════════ -->
  <div class="an-pie">
    <p class="kb-hint kb-texto-alerta an-falta" *ngIf="mensajeFaltaPaso">{{ mensajeFaltaPaso }}</p>
    <a class="kb-btn kb-btn-outline !text-foreground" [routerLink]="['/console/altas']">Cancelar</a>
    <button type="button" class="kb-btn kb-btn-outline" *ngIf="pasoActual !== 'comercio'" (click)="anterior()">
      Anterior
    </button>
    <button type="button" class="kb-btn kb-btn-primary" *ngIf="pasoActual !== 'archivo'"
            [disabled]="!puedeAvanzar" (click)="siguiente()">
      Siguiente
    </button>
    <button type="button" class="kb-btn kb-btn-primary" *ngIf="pasoActual === 'archivo'"
            [disabled]="!puedeCrear" (click)="crear()">
      <i class="fas" [ngClass]="enviando ? 'fa-spinner fa-spin' : 'fa-check'" aria-hidden="true"></i>
      {{ enviando ? 'Creando…' : 'Crear la solicitud' }}
    </button>
  </div>

</div>
